// @flow
import React, { type Node } from 'react';
import './PartneringTemplate.scss';

type Props = {
  children: Node,
};

const PartneringTemplate = ({ children }: Props) => (
  <div className="PartneringTemplate">{children}</div>
);

export default PartneringTemplate;



// WEBPACK FOOTER //
// ./src/components/partnering/PartneringTemplate/PartneringTemplate.js